<span
    class="truncate-cell"
    appTooltip
    trigger="hover"
    [component]="truncatedContentCustomTooltipComponent"
    [componentData]="{ fullText: fullText }"
    position="top"
    [showDelay]="200"
    [hideDelay]="200"
>
    {{ fullText }}
</span>
